import { type SuretyAccountId } from "@inrev/common";

export const proConsQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "pro-cons"] as const;

/** What a new pro/con on each factor would read from the account's current data. */
export const observedValuesQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "observed-values"] as const;

export const retiredProConsQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "retired-pro-cons"] as const;

export const proConRelationshipsQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "pro-con-relationships"] as const;

export const dataNeededQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "data-needed"] as const;

export const resolvedDataNeededQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "resolved-data-needed"] as const;

/** Global catalog of decisioning elements — not account-scoped. */
export const decisioningFactorsQueryKey = () => ["decisioning-factors"] as const;

/** Global catalog of element groups (per lens) — not account-scoped. */
export const decisioningFactorGroupsQueryKey = () => ["decisioning-factor-groups"] as const;

export const decisionsQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "decisions"] as const;

/** Per-user: whether the current admin can use the decisioning tool. */
export const decisioningEnabledQueryKey = () => ["decisioning", "enabled"] as const;
